import Storage from "@/utils/storage";

/** 与 ssr-web-user-center registerCouponGrants.js 一致 */
export const REGISTER_PENDING_COUPON_STORAGE_KEY = Storage.keyList.registerPendingCouponGrants;

/** 首页弹窗样式预览用 mock 券 ID（URL: ?mockRegisterCoupon=1） */
export const MOCK_REGISTER_USER_COUPON_ID = 22;

/** 模拟注册接口写入的 pending 结构 */
export function buildMockRegisterPendingCouponGrants(
  userCouponId = MOCK_REGISTER_USER_COUPON_ID,
  templateCode = "reg_ev_for_ai"
) {
  return {
    grants: [{ userCouponId, templateCode }],
    savedAt: Date.now(),
  };
}

/** 读取并清除待展示注册送券（仅弹一次） */
export function takeRegisterPendingCouponGrants() {
  if (typeof window === "undefined") return null;
  const raw = localStorage.getItem(REGISTER_PENDING_COUPON_STORAGE_KEY);
  Storage.remove("registerPendingCouponGrants");
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    const grants = parsed.grants ?? parsed.registerCouponGrants ?? parsed;
    if (grants == null) return null;
    return { grants, savedAt: parsed.savedAt ?? null };
  } catch {
    return null;
  }
}

/**
 * 注册接口 registerCouponGrants 单项结构，例如：
 * `{ userCouponId: 987654, templateCode: "reg_ev_for_ai" }`
 * 展示数据以 userCouponId 调 GET /coupon/user/coupons/{id} 为准；templateCode 仅作回退匹配辅助。
 */
export function extractUserCouponIdsFromGrants(grants) {
  if (grants == null) return [];
  const list = Array.isArray(grants) ? grants : [grants];
  const ids = [];
  for (const item of list) {
    if (item == null) continue;
    if (typeof item === "string" || typeof item === "number") {
      ids.push(String(item));
      continue;
    }
    if (typeof item !== "object") continue;
    const id =
      item.userCouponId ??
      item.user_coupon_id ??
      item.couponId ??
      item.coupon_id ??
      item.id;
    if (id != null && id !== "") ids.push(String(id));
  }
  return [...new Set(ids)];
}

/** 提取 templateCode（列表回退时辅助，用户券明细仍以 userCouponId 为主） */
export function extractTemplateCodesFromGrants(grants) {
  if (grants == null) return [];
  const list = Array.isArray(grants) ? grants : [grants];
  const codes = [];
  for (const item of list) {
    if (!item || typeof item !== "object") continue;
    const code = item.templateCode ?? item.template_code;
    if (code != null && String(code).trim() !== "") codes.push(String(code).trim());
  }
  return [...new Set(codes)];
}
